require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-bruno-brocchi.json") })
        }
      }, "path---en-interviste-bruno-brocchi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-bruno-brocchi!./.cache/json/en-interviste-bruno-brocchi.json
// module id = 580
// module chunks = 231608221292675